import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Input, Row, Space, Typography, message } from "antd";
import { Link } from "react-router-dom";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import AppLayout from "../components/layout/AppLayout";
import CustomerRequestList from "../components/transactions/CustomerRequestList";
import { getMyCustomerTransactionSchedules } from "../api/customerTransactionApi";

const { Title, Text } = Typography;

export default function MyRequestsPage() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    useEffect(() => {
        const load = async () => {
            try {
                setLoading(true);
                const data = await getMyCustomerTransactionSchedules();
                setRows(Array.isArray(data) ? data : []);
            } catch (error) {
                message.error(error.message || "Failed to load requests");
            } finally {
                setLoading(false);
            }
        };

        load();
    }, []);

    const filteredRows = useMemo(() => {
        const keyword = search.trim().toLowerCase();
        if (!keyword) return rows;

        return rows.filter((item) => {
            const fields = [
                item.requestNumber,
                item.institutionName,
                item.currency,
                item.customerSubmissionStatus,
                item.id,
            ];

            return fields.some((value) => String(value || "").toLowerCase().includes(keyword));
        });
    }, [rows, search]);

    return (
        <AppLayout>
            <Space direction="vertical" size={16} style={{ width: "100%" }}>
                <Row gutter={[16, 16]} justify="space-between" align="middle">
                    <Col xs={24} md={12}>
                        <Space direction="vertical" size={2}>
                            <Title level={2} style={{ margin: 0 }}>
                                My Requests
                            </Title>
                            <Text type="secondary">
                                Search and track all transaction requests in one place.
                            </Text>
                        </Space>
                    </Col>

                    <Col xs={24} md="auto">
                        <Button type="primary" icon={<PlusOutlined />}>
                            <Link to="/requests/new">New Request</Link>
                        </Button>
                    </Col>
                </Row>

                <Card>
                    <Space direction="vertical" size={16} style={{ width: "100%" }}>
                        <Input
                            allowClear
                            placeholder="Search by request number, institution, status, currency, or ID"
                            prefix={<SearchOutlined />}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />

                        <CustomerRequestList data={filteredRows} loading={loading} />
                    </Space>
                </Card>
            </Space>
        </AppLayout>
    );
}
